import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { fetchReportCompanyList } from '../actions/reportsActions'

const useFetchingReportCompanies = (id) => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(fetchReportCompanyList())
  }, [dispatch])
}

export default useFetchingReportCompanies
